function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  font-family: ", ";\n  color: ", ";\n  margin: 0;\n  padding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { FontFamilies as CommonFontFamilies, // TODO (lindsey-menges): remove this adjusting when new typography system is integrated and ready for release
LetterSpacings as defaultLetterSpacings, LineHeights as defaultLineHeights, Sizes as defaultSizes, Weights as defaultWeights } from '../themes/default/typography/typography-tokens';
import { css } from 'styled-components';
export { Alignments as TextAlignments, TextTransforms } from '../themes/default/typography/typography-tokens'; // TODO (lindsey-menges): remove this adjusting when new typography system is integrated and ready for release

export var returnLegacyValues = function returnLegacyValues(legacyVals) {
  var legacyLineHeights = {};
  Object.keys(legacyVals).forEach(function (keyName) {
    if (!!!parseInt(keyName, 10)) {
      legacyLineHeights[keyName] = legacyVals[keyName];
    }
  });
  return legacyLineHeights;
};
export var LineHeights = returnLegacyValues(defaultLineHeights);
export var LetterSpacings = returnLegacyValues(defaultLetterSpacings);
export var Sizes = returnLegacyValues(defaultSizes);
export var Weights = returnLegacyValues(defaultWeights);
export var FontFamilies = _objectSpread({}, CommonFontFamilies, {
  SansSerif: 'SansSerif',
  Serif: 'Serif'
});
export var fontFamily = "\n  DD-TTNorms,\n  -apple-system,\n  BlinkMacSystemFont,\n  \"Segoe UI\",\n  Roboto,\n  Helvetica,\n  Arial,\n  sans-serif,\n  \"Apple Color Emoji\",\n  \"Segoe UI Emoji\",\n  \"Segoe UI Symbol\"\n";
export var themedFontFamily = function themedFontFamily() {
  var primaryFont = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DD-TTNorms';
  return "\n  ".concat(primaryFont, ",\n  -apple-system,\n  BlinkMacSystemFont,\n  \"Segoe UI\",\n  Roboto,\n  Helvetica,\n  Arial,\n  sans-serif,\n  \"Apple Color Emoji\",\n  \"Segoe UI Emoji\",\n  \"Segoe UI Symbol\"\n");
};
export var baseStyles = css(_templateObject(), function (props) {
  return props.size;
}, function (props) {
  return themedFontFamily(props.themeFontFamily);
}, function (props) {
  return props.color;
});
export var DisplayModes = {
  Inline: 'inline',
  InlineBlock: 'inline-block',
  Block: 'block',
  Flex: 'flex'
};
export var TextWeights = {
  Thin: 'Thin',
  Light: 'Light',
  Regular: 'Regular',
  Medium: 'Medium',
  Bold: 'Bold',
  ExtraBold: 'ExtraBold' // TODO: this is an interim change to support Caviar MFP requirements and impending deadline.
  // Come back and rethink the font weight strategy across `Text` and the entire project

};
export var CaviarWeights = {
  Thin: '100',
  Light: '100',
  Regular: '300',
  Medium: '400',
  Bold: '500',
  ExtraBold: '700'
};
export var Overflows = {
  Truncate: 'truncate',
  BreakWord: 'break-word',
  Wrap: 'normal'
};